import { styled } from '@mui/system';
import { theme } from 'oems/theme';

export const Form = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Actions = styled('div')`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: flex-end;
  margin-top: 24px;
`;
